var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-jumbotron',{attrs:{"header":_vm.data['name'],"lead":_vm.data['balance']}},[_c('div',{staticClass:"w-100 text-right"},[_c('b-avatar',{attrs:{"button":"","icon":"arrow-right","disabled":""}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }